import { motion } from "framer-motion";
import { MdClose } from "react-icons/md";
import CheckboxItem from "../components/dropdown-menu/CheckboxItem";

interface FilterDropdownListProps {
  className?: string;
  options: { text: string; value: string }[];
  selectedOptions: string[];
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>;
}

const FilterDropdownList: React.FC<FilterDropdownListProps> = ({
  options,
  selectedOptions,
  setSelectedOptions,
}) => {
  /**
   * Function executed when clicking one of the options
   * @param option
   * @returns
   */
  const handleClickOption = (option: { text: string; value: string }) => {
    return () => {
      // If the element is selected, then remove
      if (selectedOptions.includes(option.value)) {
        setSelectedOptions((currentList) =>
          currentList.filter((item) => option.value !== item)
        );
      }
      // Otherwise,add to the list
      else {
        setSelectedOptions((currentList) => [...currentList, option.value]);
      }
    };
  };

  /**
   * Function used to unselect all of the elements
   */
  const handleClickClearAll = () => {
    setSelectedOptions([]);
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.3, ease: "easeOut" }}
      className="absolute left-0 top-10 p-3 bg-white rounded-lg shadow-dropdown-list inline-flex flex-col justify-center items-center gap-2 z-30"
    >
      <div className="max-h-[30vh] flex flex-col gap-2 overflow-y-auto pop-up-scrollbar">
        {options &&
          options.length > 0 &&
          options.map(
            (option: { text: string; value: string }, index: number) => (
              <CheckboxItem
                key={index}
                text={option.text}
                selected={selectedOptions.includes(option.value)}
                onClickFunction={handleClickOption(option)}
              />
            )
          )}
      </div>
      <div
        className="pl-4 pr-3 py-2 bg-neutral-50 hover:bg-neutral-100 ease-in-out duration-150 rounded-full inline-flex justify-center items-center gap-2 cursor-pointer"
        onClick={handleClickClearAll}
      >
        <div className="justify-start text-neutral-700 text-sm font-normal font-sans leading-none">
          Clear all
        </div>
        <MdClose className="w-4 h-4 relative fill-neutral-700" />
      </div>
    </motion.div>
  );
};

export default FilterDropdownList;
